const GOOGLE_ENGINE_ID_DE = '015779229714119427756:ffeaeyhxk6y';
const GOOGLE_ENGINE_ID_FR = '015779229714119427756:lfzacflwnfw';
const GOOGLE_ENGINE_ID_ES = '015779229714119427756:1g0wxjzweju';
const GOOGLE_ENGINE_ID_EN = '015779229714119427756:xnub-tjdvbc';

const GOOGLE_ENGINE_IDS = {
    'de': GOOGLE_ENGINE_ID_DE,
    'fr': GOOGLE_ENGINE_ID_FR,
    'es': GOOGLE_ENGINE_ID_ES,
    'en': GOOGLE_ENGINE_ID_EN,
};

export { GOOGLE_ENGINE_IDS };
